import { fetchPatientData } from './patientActions';
import { SERVER_ADDRESS, fetchPost } from '../util/actionsUtil';

export const UPDATE_WCC_LOADING = 'UPDATE_WCC_LOADING';
export const UPDATE_WCC_SUCCESS = 'UPDATE_WCC_SUCCESS';
export const UPDATE_WCC_ERROR = 'UPDATE_WCC_ERROR';

export function updateWellChildCheck(patientId: string, wellChildCheck: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/wellChildCheck/updateWellChildCheck`,
      {
        ...wellChildCheck,
        patientId,
      },
      (data) => {
        dispatch({
          type: UPDATE_WCC_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: UPDATE_WCC_ERROR,
          error: error.toString(),
        });
      },
    );
    dispatch({
      type: UPDATE_WCC_LOADING,
    });
  });
}



// WEBPACK FOOTER //
// ./client/src/actions/wellChildCheckActions.js